import { render, staticRenderFns } from "./ChatMensagem.vue?vue&type=template&id=0f3d61cc"
import script from "./ChatMensagem.vue?vue&type=script&lang=js"
export * from "./ChatMensagem.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagem.vue?vue&type=style&index=0&id=0f3d61cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports